export const isPartiallyVisible = (elem: Element) => {
  const elementBoundary: DOMRect = elem.getBoundingClientRect()

  const top: number = elementBoundary.top
  const bottom: number = elementBoundary.bottom
  const height: number = elementBoundary.height

  return top + height >= 0 && height + window.innerHeight >= bottom
}
